import Link from 'next/link';
import css from './styles/footer.module.css';

const COPYRIGHT_TEXT = 'Copyright \u00A9 2023 Bibcitation.';

const Footer: React.FC = () => {
  return (
    <footer className={css.main}>
      <div className={css.mobile}>
        <div className={css.mobileDivider} />
        <div className={css.mobileLinks}>
          <Link href="/about">About</Link>
          <Link href="/contact">Contact</Link>
          <Link href="/terms">Terms</Link>
          <Link href="/privacy">Privacy</Link>
        </div>
        <div className={css.mobileCopyright}>{COPYRIGHT_TEXT}</div>
      </div>

      <div className={css.desktop}>
        <div className={css.divider} />

        <div className={css.sectionTitle}>Discover our add-ons</div>
        <div className={css.sectionLinks}>
          <Link href="https://workspace.google.com/marketplace/app/bibcitation_bibliography_citation_genera/355051276479">
            Bibcitation for Google Docs
          </Link>
          <Link href="https://chrome.google.com/webstore/detail/bibcitation-%E2%80%94-free-instan/cnjkoanefhlhkagbpofjbafaonfejpgc">
            Bibcitation for Google Chrome
          </Link>
          <Link href="https://appsource.microsoft.com/en-us/product/office/WA200004996?exp=ubp8">
            Bibcitation for Microsoft Word
          </Link>
        </div>

        <div className={css.sectionTitle}>For organizations</div>
        <div className={css.sectionLinks}>
          <Link href="/for-organizations">Integration for libraries</Link>
          <Link href="/for-organizations">Integration for companies</Link>
          <Link href="/for-organizations">Integration for universities</Link>
        </div>

        <div className={css.sectionTitle}>For students</div>
        <div className={css.sectionLinks}>
          <Link href="/blog/" prefetch={false}>
            Bibcitation Blog
          </Link>
          <Link href="/blog/apa-format.html" prefetch={false}>
            APA Format Guide
          </Link>
          <Link href="/blog/apa-format.html" prefetch={false}>
            MLA Format Guide
          </Link>
        </div>

        <div className={css.mainLinks}>
          <Link href="/about">About</Link>
          {' / '}
          <Link href="/privacy">Privacy</Link>
          {' / '}
          <Link href="/terms">Terms of Use</Link>
          {' / '}
          <Link href="/contact">Contact</Link>
        </div>

        <div className={css.finalSection}>
          <div className={css.copyright}>{COPYRIGHT_TEXT}</div>
          <div className={css.socialMedia}>
            <a href="https://twitter.com/bibcitationapp">
              <img src={require('images/tw.png')} alt="Twitter logo" />
            </a>
            <a href="https://www.instagram.com/bibcitation/">
              <img src={require('images/insta.png')} alt="Instagram logo" />
            </a>
            <a href="https://www.facebook.com/bibcitation">
              <img src={require('images/fb.png')} alt="Facebook logo" />
            </a>
            <a href="https://www.youtube.com/@bibcitation6606">
              <img src={require('images/youtube.png')} alt="YouTube logo" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
